import JSON5 from 'json5';
require('jquery.scrollto');

export default class ScrollTo{
	constructor($el){
        let selector = $el.selector;

        const options = {
        	sideglossary:{
        		onAfter: function(){
    				$('.o-sideglossaryindex__row').removeClass('is-indicator-disabled');
        		}
        	}
        }

        let callback = (e) => {
        	e.stopPropagation();
            let $this = $(e.currentTarget);
            if($this.data('scrollto')){
                e.preventDefault();
                var opt = JSON5.parse($this.data('scrollto'));

                if(opt.key){
                	opt.settings = $.extend(true, opt.settings, options[opt.key]);

                	if(opt.key == 'sideglossary' && $(opt.target).length){
                		$('.o-sideglossaryindex__row').addClass('is-indicator-disabled');
                	}
                }

                if(opt.delay){
                    setTimeout(function(){
                         $.scrollTo(opt.target, opt.duration || 800, opt.settings);
                     }, opt.delay || 0);
                }
                $.scrollTo(opt.target, opt.duration || 800, opt.settings);
                $(opt.target).focus();
            }
        };

        if(selector){
            $(document).on('click touchstart', selector, callback);
        } else{
            $el.on('click touchstart', callback);
        }
	}
}



// WEBPACK FOOTER //
// ./src/_js/partials/ScrollTo.js